/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics interface.
 */
export function instanceOfFxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics(value) {
    if (!('Elapsed' in value) || value['Elapsed'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Elapsed': json['Elapsed'],
        'RowsRead': json['RowsRead'] == null ? undefined : json['RowsRead'],
        'BytesRead': json['BytesRead'] == null ? undefined : json['BytesRead'],
    };
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Elapsed': value['Elapsed'],
        'RowsRead': value['RowsRead'],
        'BytesRead': value['BytesRead'],
    };
}
//# sourceMappingURL=FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics.js.map